<template>
    <div class="movieLabel">
        <ul class="labels_top_list_left" style="gap: 0">
            <li v-if="labels.isUzb || labels.isExclusiveTranslate">
                <div class="label_list_item provider_img">
                    <img :src="whichLabelImg" alt="Tvcom provider uzb" />
                </div>
            </li>

            <li v-if="labels.providerImg">
                <div class="label_list_item provider_img">
                    <img
                        :src="`https://api.tvcom.uz/storage/${labels.providerImg}`"
                        alt="Tvcom provider"
                    />
                </div>
            </li>

            <!-- <li
                v-if="
                    checkAccess
                        ? (labels.providerImg || labels.isExclusiveTranslate) &&
                          item.has_subscription === 0
                        : !labels.providerImg &&
                          !labels.isExclusiveTranslate &&
                          !labels.isUzb &&
                          !labels.tvcom
                "
                :style="{
                    marginTop:
                        labels.isUzb ||
                        labels.isExclusiveTranslate ||
                        labels.providerImg ||
                        labels.tvcom
                            ? '0'
                            : '1.8rem'
                }"
            >
                <div class="label_list_item has_subscription">
                    <span class="label_item_text">
                        {{ $t(`message.has_subscription`) }}</span
                    >
                </div>
            </li>
            <li
                v-if="
                    (checkAccess &&
                        !labels.providerImg &&
                        !labels.isExclusiveTranslate) ||
                        (!checkAccess && labels.isUzb) ||
                        (!checkAccess && labels.tvcom) ||
                        (checkAccess && item.has_subscription === 1)
                "
            >
                <div
                    class="label_list_item free_movie"
                    :style="{
                        marginTop:
                            labels.isUzb ||
                            labels.isExclusiveTranslate ||
                            labels.providerImg ||
                            !labels.tvcom
                                ? '0'
                                : '1.8rem'
                    }"
                >
                    <span class="label_item_text">
                        {{ $t(`message.free_movie`) }}</span
                    >
                </div>
            </li> -->
        </ul>

        <div class="labels_list_right" v-if="labels.is4K || isGenresHave4k">
            <img
                src="../../assets/icons/movie_4K.svg"
                alt="Tvcom 4K"
                class="movie_4K"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import exclusiveTarjima from "../../assets/icons/exclusiveTarjima.png";
import uzbLabel from "../../assets/icons/shildikUzb.svg";

export default {
    name: "MovieCardLabel",

    props: {
        item: {
            type: Object,
        },
    },

    data: () => ({
        isLoggedIn: false,
    }),

    mounted() {
        this.isLoggedIn = localStorage.getItem("token");
    },

    computed: {
        ...mapGetters(["getProviders", "checkAccess"]),

        providers() {
            return this.getProviders.reduce((acc, el) => {
                if (!acc[el.provider_id]) acc[el.provider_id] = el;
                return acc;
            }, {});
        },

        labels() {
            const item = this.item;
            const is4K = !!this.check4K(item.files);
            const providerImg = this.providers[item.video_provider_id]?.img;
            const hasSubscription = item.has_subscription;
            // const isExclusiveTranslate = +item.video_provider_id === 10;
            const isExclusiveTranslate = false;
            const isUzb =
                +item.video_provider_id === 3 &&
                item?.genres.includes("Узбекский");
            const tvcom = +item.video_provider_id === 3;

            return {
                providerImg,
                isUzb,
                tvcom,
                isExclusiveTranslate,
                hasSubscription,
                is4K,
            };
        },

        whichLabelImg() {
            const item = this.item;
            const img =
                +item.video_provider_id === 3 &&
                item?.genres.includes("Узбекский")
                    ? uzbLabel
                    : // : +item.video_provider_id === 10
                      // ? exclusiveTarjima
                      "none";

            return img;
        },

        isGenresHave4k() {
            const itemIsInclude4k = this.item.genres.includes("4K");
            return itemIsInclude4k;
        },
    },

    methods: {
        check4K(videos) {
            if (!videos) return;
            const is4K = videos.find((el) => el.quality === 6);
            return !!is4K;
        },
    },
};
</script>
<style lang="scss" scoped>
.movieLabel {
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: -1px;
    width: 100%;
    z-index: 2;
}
.labels_list_right,
.labels_list_left {
    list-style-type: none;
    display: flex;
    width: auto;
    gap: 5px;
    transition: 0.3s;
}

.labels_list_right {
    gap: 0;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 1.8rem;
}

.labels_list_right > img {
    height: 30px;
}

.labels_list_left {
    flex-direction: column;
}

.label_list_item {
    display: flex;
}

.label_item_text {
    width: 100%;
    text-align: center;
}

.movie_4K {
    /* background: #363636;
    padding: 5px;
    font-weight: 500;
    font-size: 16px; */
    grid-row-start: 2;
}

/* .labels_list_left > li,
.labels_list_right > li {
    display: flex;
} */

.provider_img > img {
    height: 30px;
}

.labels_top_list_left {
    list-style-type: none;
    flex-direction: column;
    transition: 0.3s;
}
.free_movie {
    font-size: 16px;
    background: #20b433;
    padding: 5px 8px;
}
.exclusive,
.premier,
.new_episodes,
.has_subscription {
    font-size: 16px;
    background: #e41a4b;
    padding: 5px 8px;
}

@media screen and (min-width: 1660px) {
    .provider_img > img {
        height: 33px;
    }

    .labels_list_right > img {
        height: 33px;
    }
    .free_movie {
        font-size: 18px;
        padding: 5px 8px;
    }
}

@media screen and (max-width: 700px) {
    .provider_img {
        left: 0;
    }

    .provider_img > img {
        height: 25px;
    }

    .labels_list_left {
        gap: 4px;
        top: 6px;
        left: 0;
    }
    .labels_top_list_left {
        grid-template-rows: 25px 1fr;
    }
    .free_movie,
    .exclusive,
    .premier,
    .new_episodes,
    .has_subscription {
        font-size: 14px;
        padding: 4px 7px;
    }

    .labels_list_right > img {
        height: 25px;
    }
}
</style>
